import * as yup from "yup";
import { getStringRequiredFieldMessage } from "@shared/utils/yup-extensions";

export const subscriptionFlowChangeEmailFormSchema: yup.ObjectSchema<SubscriptionFlowChangeEmailSchema> =
  yup
    .object({
      email: yup
        .string()
        .email()
        .trim()
        .min(1, getStringRequiredFieldMessage)
        .required()
        .label("Email"),
    })
    .required();

export const SUBSCRIPTION_FLOW_CHANGE_EMAIL_SCHEMA_DEFAULT_VALUES = {
  email: "",
};
export type SubscriptionFlowChangeEmailSchema =
  typeof SUBSCRIPTION_FLOW_CHANGE_EMAIL_SCHEMA_DEFAULT_VALUES;

export const subscriptionFlowTokenValidationFormSchema: yup.ObjectSchema<SubscriptionFlowTokenValidationSchema> =
  yup
    .object({
      token: yup
        .string()
        .trim()
        .min(1, getStringRequiredFieldMessage)
        .required()
        .label("Token"),
    })
    .required();

export const SUBSCRIPTION_FLOW_TOKEN_VALIDATION_SCHEMA_DEFAULT_VALUES = {
  token: "",
};
export type SubscriptionFlowTokenValidationSchema =
  typeof SUBSCRIPTION_FLOW_TOKEN_VALIDATION_SCHEMA_DEFAULT_VALUES;

const digit = /[0-9a-zA-Z]/;
const spaces = [" ", " ", " ", " "];
export const changeEmailTokenMask = [
  digit,
  ...spaces,
  digit,
  ...spaces,
  digit,
  ...spaces,
  digit,
  ...spaces,
  digit,
  ...spaces,
  digit,
];
